import { rankItems, reportMeta, hotTopics } from "@/mocks/gossip";

const catColor: Record<string, string> = {
  明星: "bg-[rgb(204,38,39)]/20 text-[rgb(244,115,115)]",
  网红: "bg-[rgb(126,158,106)]/20 text-[rgb(178,200,158)]",
  主播: "bg-[rgb(244,146,36)]/20 text-[rgb(244,180,120)]",
};

function Trend({ trend }: { trend: "up" | "down" | "flat" }) {
  if (trend === "up")
    return (
      <span className="flex items-center gap-0.5 text-[rgb(74,222,128)]">
        <i className="ri-arrow-up-line h-3.5 w-3.5 flex items-center justify-center"></i>
      </span>
    );
  if (trend === "down")
    return (
      <span className="flex items-center gap-0.5 text-[rgb(129,140,248)]">
        <i className="ri-arrow-down-line h-3.5 w-3.5 flex items-center justify-center"></i>
      </span>
    );
  return <span className="text-[rgb(var(--paper))]/40">持平</span>;
}

export default function HotRank() {
  return (
    <section
      id="rank"
      className="w-full bg-[rgb(var(--ink))] text-[rgb(var(--paper))]"
    >
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-3">
        {/* 左：榜单 */}
        <div className="lg:col-span-2">
          <div className="mb-5 flex items-end justify-between">
            <div>
              <div className="mb-2 flex items-center gap-2 text-[12px] font-semibold tracking-[0.25em] text-[rgb(244,115,115)]">
                <i className="ri-focus-3-line h-4 w-4 flex items-center justify-center"></i>
                LIVE RANKING
              </div>
              <h2 className="font-display text-[24px] font-black leading-tight md:text-[30px]">
                实时热瓜榜
              </h2>
            </div>
            <span className="flex items-center gap-2 rounded-full border border-[rgb(var(--paper))]/15 px-3 py-1.5 text-[12px]">
              <span className="h-1.5 w-1.5 animate-live rounded-full bg-[rgb(74,222,128)]"></span>
              每 5 分钟刷新
            </span>
          </div>

          <div className="flex flex-col divide-y divide-[rgb(var(--paper))]/8 rounded-lg border border-[rgb(var(--paper))]/10 bg-[rgb(var(--paper))]/[0.03]">
            {rankItems.map((r) => (
              <a
                key={r.id}
                href="#timeline"
                className="group flex items-center gap-3 px-3 py-3 transition-colors hover:bg-[rgb(var(--paper))]/5 md:px-4"
              >
                <span
                  className={`w-7 shrink-0 text-center font-display text-[20px] font-black ${
                    r.id <= 3 ? "text-[rgb(244,115,115)]" : "text-[rgb(var(--paper))]/45"
                  }`}
                >
                  {String(r.id).padStart(2, "0")}
                </span>
                <span
                  className={`hidden shrink-0 rounded-md px-1.5 py-0.5 text-[11px] font-medium sm:block ${catColor[r.category]}`}
                >
                  {r.category}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-display truncate text-[14px] font-bold group-hover:text-[rgb(244,115,115)] md:text-[15px]">
                      {r.name} · {r.title}
                    </h3>
                  </div>
                  <p className="mt-0.5 truncate text-[12px] text-[rgb(var(--paper))]/55">
                    {r.note}
                  </p>
                </div>
                <span className="hidden shrink-0 text-[12px] text-[rgb(var(--paper))]/50 md:block">
                  {r.heat}
                </span>
                <Trend trend={r.trend} />
                <i className="ri-arrow-right-s-line h-4 w-4 shrink-0 flex items-center justify-center text-[rgb(var(--paper))]/30"></i>
              </a>
            ))}
          </div>
          <div className="mt-4 flex flex-col items-center justify-between gap-3 sm:flex-row">
            <p className="text-[12px] text-[rgb(var(--paper))]/50">
              热度由围观、转发与评论加权得出，仅反映舆论活跃度
            </p>
            <a
              href="#today"
              className="flex items-center gap-1 whitespace-nowrap text-[13px] font-medium text-[rgb(244,146,36)] transition-colors hover:text-[rgb(244,180,120)]"
            >
              查看完整榜单
              <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        {/* 右：围观情报站 */}
        <div className="flex flex-col gap-4">
          <div className="rounded-lg border border-[rgb(var(--paper))]/10 bg-[rgb(var(--paper))]/[0.04] p-5">
            <div className="mb-3 flex items-center gap-2 text-[12px] font-semibold tracking-[0.2em] text-[rgb(244,146,36)]">
              <i className="ri-radar-line h-4 w-4 flex items-center justify-center"></i>
              围观情报站
            </div>
            <div className="grid grid-cols-2 gap-3">
              {reportMeta.map((m) => (
                <div
                  key={m.label}
                  className="rounded-md border border-[rgb(var(--paper))]/10 bg-black/20 p-3"
                >
                  <p className="font-display text-[22px] font-black leading-none text-[rgb(var(--paper))]">
                    {m.value}
                  </p>
                  <p className="mt-1.5 text-[11px] text-[rgb(var(--paper))]/55">{m.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 rounded-lg border border-[rgb(var(--paper))]/10 bg-[rgb(var(--paper))]/[0.04] p-5">
            <div className="mb-3 flex items-center justify-between">
              <div className="flex items-center gap-2 text-[12px] font-semibold tracking-[0.2em] text-[rgb(74,222,128)]">
                <i className="ri-fire-fill h-4 w-4 flex items-center justify-center"></i>
                正在热议
              </div>
              <span className="flex items-center gap-1.5 text-[11px] text-[rgb(var(--paper))]/45">
                <span className="h-1.5 w-1.5 animate-live rounded-full bg-[rgb(74,222,128)]"></span>
                实时
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              {hotTopics.map((t) => (
                <a
                  key={t}
                  href="#rank"
                  className="whitespace-nowrap rounded-full border border-[rgb(var(--paper))]/12 bg-[rgb(var(--paper))]/5 px-3 py-1.5 text-[12px] text-[rgb(var(--paper))]/75 transition-colors hover:border-[rgb(244,146,36)]/50 hover:text-[rgb(244,180,120)]"
                >
                  #{t}
                </a>
              ))}
            </div>
            <div className="mt-5 flex items-center gap-2 rounded-md border border-[rgb(244,146,36)]/30 bg-[rgb(244,146,36)]/10 p-3 text-[12px] text-[rgb(var(--paper))]/80">
              <i className="ri-megaphone-line h-4 w-4 shrink-0 flex items-center justify-center text-[rgb(244,180,120)]"></i>
              有独家线索？点这里向编辑小报匿名递瓜。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}